/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React from "react";


import MonthDetailsPane from "../MonthDetailsPane";


// We may not need this but leaving it for now
function MonthDetails(props) {

  return (
    <div>
      <MonthDetailsPane results={props.results} />
    </div>
  );
}

export default MonthDetails;

